<!-- View Mode - when not editing -->
<div *ngIf="!isEdited" class="cell-view" [style]="showLabel ? {} : { 'justify-content': 'center' }">
  <!-- Status Display - same for all states -->
  <div *ngIf="!showLabel" class="flex align-items-center">
    <i
      [class]="rowData[fieldName]?.icon"
      [ngStyle]="{ color: rowData[fieldName]?.color }"
      class="text-2xl vertical-align-middle align-self-center"
      [pTooltip]="rowData[fieldName]?.name"
    >
    </i>
  </div>

  <div *ngIf="showLabel" class="flex align-items-center" [pTooltip]="rowData[fieldName]?.description">
    <i [class]="rowData[fieldName]?.icon" [ngStyle]="{ color: rowData[fieldName]?.color }" class="text-2xl mr-2"> </i>
    <span>{{ rowData[fieldName]?.name }}</span>
  </div>

  <!-- Edit Menu -->
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="FsmCell_Button_edit"
      icon="pi pi-pencil"
      pTooltip="Status ändern"
      (click)="onEdit()"
    ></button>
  </div>
</div>

<!-- Edit Mode -->
<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <p-dropdown
      #dropdown
      [placeholder]="rowData[fieldName] ? rowData[fieldName].name : fieldName"
      class="dropdown-full-width"
      [name]="fieldName"
      [options]="options"
      [panelStyle]="{ 'max-width': '250px' }"
      [style]="{ width: '100%' }"
      [ngModel]="rowData[fieldName]"
      (keyup.esc)="abortCellEdit($event)"
      (onChange)="onTransitionSelected($event)"
      emptyMessage="Keine Ergebnisse gefunden"
      (clickOutside)="abortCellEdit($event)"
      jmlAutoFocus
      jmlStopClickPropagation
      jmlClickOutside
      appendTo="body"
    >
      <ng-template let-item pTemplate="item">
        <i
          [class]="item.value.stateIcon"
          [ngStyle]="{ color: item.value.stateColor }"
          [pTooltip]="item.value.stateDescription"
          class="text-3xl vertical-align-middle pr-2"
        >
        </i>
        {{ item.label }}
      </ng-template>
    </p-dropdown>
  </div>
</ng-template>
